import { defineNamespace, ConsumerTypes, ApiVersions } from '../../common';
import {
  platformAPICreator as platformAPICreatorV1Internal,
  IPlatformAPIDefinition as IPlatformAPV1InternalIDefinition,
} from './accessibility.internal.v1';
import {
  platformAPICreator as platformAPICreatorV2Internal,
  IPlatformAPIDefinition as IPlatformAPV2Interna2lIDefinition,
} from './accessibility.internal.v2';

export * from './accessibility.super';

export type INamespaceDefinition =
  | IPlatformAPV1InternalIDefinition
  | IPlatformAPV2Interna2lIDefinition;

export const namespaceCreator = defineNamespace<INamespaceDefinition>(
  (config) => {
    if (
      config.consumerType === ConsumerTypes.Internal &&
      config.version === ApiVersions.V1
    ) {
      return platformAPICreatorV1Internal(config.superAPI)(config.context);
    }

    if (
      config.consumerType === ConsumerTypes.Internal &&
      config.version === ApiVersions.V2
    ) {
      return platformAPICreatorV2Internal(config.superAPI)(config.context);
    }

    return null;
  },
);
